import { detectIOS, detectAndroid } from 'src/libs/platform/detectors';
import { canUseDOM } from 'src/libs/canUseDOM';

let cache: Constants | null = null;
type Constants = {
  isIOS: boolean;
  isAndroid: boolean;
  isIPad: boolean;
  isIPadOS: boolean;
  OS: 'ios' | 'android' | 'web' | 'macos' | 'windows';
};

export const Platform = {
  get constants() {
    if (cache === null) {
      const { isIOS, isIPad, isIPadOS } = detectIOS();
      const { isAndroid } = detectAndroid();

      cache = {
        isIOS,
        isAndroid,
        isIPad,
        isIPadOS,
        OS: isIOS || isIPad || isIPadOS ? 'ios' : isAndroid ? 'android' : 'web',
      };
    }

    return cache;
  },
  get isAndroid() {
    return this.constants.isAndroid;
  },
  get isIPadOS() {
    return this.constants.isIPadOS;
  },
  get isIPad() {
    return this.constants.isIPad;
  },
  get isIOS() {
    return this.constants.isIOS;
  },
  get OS() {
    return this.constants.OS;
  },
  get isPad() {
    return this.constants.isIPad;
  },
  get isTVOS() {
    return false;
  },
  get isTV() {
    return false;
  },
  get isWeb() {
    return canUseDOM();
  },
  select: (obj: any) => {
    const os = Platform.OS;

    return os in obj ? obj[os] : 'web' in obj ? obj.web : obj.default;
  },
  get isTesting() {
    return process.env.NODE_DEV === 'test';
  },
};
